// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.disabled[data-v-c19025f8]{opacity:.3;cursor:not-allowed;pointer-events:none}.fixed-bottom-middle[data-v-c19025f8]{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:1}.has-min-width[data-v-c19025f8]{min-width:134px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
